<template>
  <!-- <b-input-group>
    <b-input-group-prepend is-text>Rp</b-input-group-prepend>
    <b-form-input
      v-bind="$attrs"
      :value="formattedValue"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      @keypress="onKeyPress"
      @paste="onPaste"
      v-on="$listeners"
      ref="input"
    />
  </b-input-group> -->
  <b-form-input
    v-bind="$attrs"
    :value="formattedValue"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    @keypress="onKeyPress"
    @paste="onPaste"
    v-on="$listeners"
    ref="input"
  />
</template>

<script>
export default {
  name: 'RupiahInput',
  inheritAttrs: false, // penting agar $attrs bisa digunakan di input, bukan root
  props: {
    value: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      rawValue: this.value,
      isFocused: false,
    };
  },
  computed: {
    formattedValue() {
      if (this.isFocused) {
        return this.rawValue.toString();
      }

      // return new Intl.NumberFormat('id-ID', {
      return (
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
          .format(this.rawValue)
          // .replace('IDR', 'Rp.') // Hanya untuk en-US
          .replace('IDR', '')
      ); // Hilangkan \"IDR\" karena sudah ditampilkan manual
      // .replace(/^Rp\\s?/, '') // Hilangkan \"Rp\" karena sudah ditampilkan manual
    },
  },
  watch: {
    value(newVal) {
      const numeric = parseInt(newVal.replace(/\\D/g, '')) || 0;
      this.rawValue = numeric;
    },
  },
  methods: {
    onInput(val) {
      const numeric = parseInt(val.replace(/\\D/g, '')) || 0;
      this.rawValue = numeric;
      this.$emit('input', numeric);
    },
    onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
    onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    onKeyPress(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    onPaste(event) {
      const pasteData = event.clipboardData.getData('Text');
      if (/\\D/.test(pasteData)) {
        event.preventDefault();
      }
    },
    focus() {
      this.$refs.input?.focus();
    },
  },
};
</script>
